/* funnls - Bloom trio offer page. No prices are computed here: every number
   on the page is rendered by Liquid from the live product. This file only
   moves things around. */
(function () {
  'use strict';

  // Every funnls-bloom section renders the head snippet, so this file is on
  // the page once per section - and a browser runs a repeated <script> every
  // time (it only dedupes stylesheets). Thirteen copies bound thirteen tap
  // handlers to each video: the first played it, the next paused it, and the
  // "retry muted" fallback left it silent (Ben, 2026-09-25: "why do the
  // videos not have sound?"). Run once; bind() makes re-runs idempotent too.
  if (window.__funnlsBloom) return;
  window.__funnlsBloom = true;

  function bind(el, key) {
    var k = 'mbBound' + key;
    if (el.dataset[k]) return false;
    el.dataset[k] = '1';
    return true;
  }

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Reveal on scroll. The hidden state is gated on .mb-js (set before this
  // file loads), and anything already on screen is shown at once.
  function reveals() {
    var els = document.querySelectorAll('.mb-reveal:not(.is-in)');
    if (!('IntersectionObserver' in window) || reduce) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  // Gallery: native scroll-snap does the swiping; the thumbs follow it.
  function galleries() {
    document.querySelectorAll('[data-mb-gallery]').forEach(function (g) {
      var track = g.querySelector('[data-mb-gallery-track]');
      var slides = g.querySelectorAll('[data-mb-slide]');
      var thumbs = g.querySelectorAll('[data-mb-thumb]');
      if (!track || !thumbs.length || !bind(g, 'Gallery')) return;
      function mark(i) { thumbs.forEach(function (t, n) { t.classList.toggle('is-on', n === i); t.setAttribute('aria-selected', n === i); }); }
      thumbs.forEach(function (t) {
        t.addEventListener('click', function () {
          var i = +t.getAttribute('data-mb-thumb');
          track.scrollTo({ left: slides[i].offsetLeft - track.offsetLeft, behavior: reduce ? 'auto' : 'smooth' });
          mark(i);
        });
      });
      // 2026-10-02 (CRO audit): prev / next arrows over the photo, desktop
      // only (CSS hides them on phones, where swiping is the gesture).
      function go(step) {
        var i = Math.round(track.scrollLeft / track.clientWidth) + step;
        i = (i + slides.length) % slides.length;
        track.scrollTo({ left: slides[i].offsetLeft - track.offsetLeft, behavior: reduce ? 'auto' : 'smooth' });
        mark(i);
      }
      if (slides.length > 1) {
        [['prev', -1, 'Previous photo'], ['next', 1, 'Next photo']].forEach(function (a) {
          var btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'mb-gallery__arrow mb-gallery__arrow--' + a[0];
          btn.setAttribute('aria-label', a[2]);
          btn.innerHTML = '<svg viewBox="0 0 16 16" width="16" height="16" aria-hidden="true"><path d="' +
            (a[1] < 0 ? 'M10 3 5 8l5 5' : 'M6 3l5 5-5 5') +
            '" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>';
          btn.addEventListener('click', function () { go(a[1]); });
          g.appendChild(btn);
        });
      }
      var raf;
      track.addEventListener('scroll', function () {
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(function () { mark(Math.round(track.scrollLeft / track.clientWidth)); });
      }, { passive: true });
    });
  }

  // Videos: one plays at a time, with sound, on a tap.
  function videos() {
    var all = [];
    document.querySelectorAll('[data-mb-vid]').forEach(function (card) {
      var v = card.querySelector('video');
      var btn = card.querySelector('[data-mb-vid-toggle]');
      if (!v || !btn) return;
      all.push(v);
      if (!bind(card, 'Vid')) return;
      function sync() {
        var on = !v.paused && !v.ended;
        card.classList.toggle('is-playing', on);
        btn.setAttribute('aria-label', on ? 'Pause video' : 'Play video');
      }
      btn.addEventListener('click', function () {
        if (v.paused || v.ended) {
          all.forEach(function (o) { if (o !== v) o.pause(); });
          v.muted = false;
          var p = v.play();
          // Muted only when the browser actually refuses sound; any other
          // rejection (an interrupted load) is left alone.
          if (p && p.catch) p.catch(function (err) {
            if (err && err.name === 'NotAllowedError') { v.muted = true; v.play(); }
          });
        } else {
          v.pause();
        }
      });
      ['play', 'pause', 'ended'].forEach(function (ev) { v.addEventListener(ev, sync); });
    });

    // Pause whatever is playing once it is scrolled out of view.
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { if (!e.isIntersecting && !e.target.paused) e.target.pause(); });
      }, { threshold: 0.25 });
      all.forEach(function (v) { io.observe(v); });
    }

    document.querySelectorAll('.mb-videos').forEach(function (s) {
      var track = s.querySelector('[data-mb-vids]');
      var prev = s.querySelector('[data-mb-vid-prev]');
      var next = s.querySelector('[data-mb-vid-next]');
      if (!track || !bind(s, 'Arrows')) return;
      function step(dir) {
        var card = track.querySelector('[data-mb-vid]');
        var w = card ? card.getBoundingClientRect().width + 14 : 300;
        track.scrollBy({ left: dir * w, behavior: reduce ? 'auto' : 'smooth' });
      }
      if (prev) prev.addEventListener('click', function () { step(-1); });
      if (next) next.addEventListener('click', function () { step(1); });
    });
  }

  // Sticky bar: on once the hero button is gone, off while the second offer
  // is on screen, so two buy buttons never stack.
  function sticky() {
    var bar = document.querySelector('[data-mb-sticky]');
    var hero = document.querySelector('[data-mb-hero-cta]');
    if (!bar || !hero || !('IntersectionObserver' in window) || !bind(bar, 'Sticky')) return;
    var offer = document.querySelector('[data-mb-offer-section]');
    var heroGone = false, offerOn = false;
    function set() {
      var on = heroGone && !offerOn;
      bar.classList.toggle('is-on', on);
      bar.setAttribute('aria-hidden', on ? 'false' : 'true');
      bar.querySelectorAll('a').forEach(function (a) { a.tabIndex = on ? 0 : -1; });
    }
    new IntersectionObserver(function (es) {
      es.forEach(function (e) { heroGone = !e.isIntersecting && e.boundingClientRect.top < 0; });
      set();
    }).observe(hero);
    if (offer) {
      new IntersectionObserver(function (es) {
        es.forEach(function (e) { offerOn = e.isIntersecting; });
        set();
      }, { threshold: 0.2 }).observe(offer);
    }
    set();
  }

  // "Jump to the offer" buttons scroll smoothly (anchor href still works
  // without script).
  function jumps() {
    document.querySelectorAll('[data-mb-jump]').forEach(function (a) {
      if (!bind(a, 'Jump')) return;
      a.addEventListener('click', function (ev) {
        var t = document.querySelector(a.getAttribute('href'));
        if (!t) return;
        ev.preventDefault();
        t.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
      });
    });
  }

  // After an add, stay on the page and open UpCart's drawer (Ben, 2026-10-05:
  // the drawer flashed, then the page jumped to /cart). EasyGift still adds
  // the gifts - it reacts to the /cart/add.js call, not to the /cart page.
  // Only when UpCart hasn't loaded does the shopper go to /cart.
  function openCart(el, root) {
    var w = window;
    if (typeof w.upcartOpenCart !== 'function' && typeof w.upcartRefreshCart !== 'function') {
      window.location.href = root + 'cart';
      return;
    }
    try { if (typeof w.upcartRegisterAddToCart === 'function') w.upcartRegisterAddToCart(); } catch (e) {}
    try { if (typeof w.upcartRefreshCart === 'function') w.upcartRefreshCart(); } catch (e) {}
    try { if (typeof w.upcartOpenCart === 'function') w.upcartOpenCart(); } catch (e) {}
    el.removeAttribute('aria-busy');
    el.style.pointerEvents = '';
  }

  // Buy buttons: a normal add-to-cart (/cart/add.js) of the three bottles,
  // then the cart drawer. EasyGift adds the free e-book and wipe only on a
  // normal add - never when a cart link fills the cart - so the link in href
  // is just the no-script fallback. Links, not forms: a /cart/add form got
  // UpCart's rewrite (a 400) and Subify's subscribe picker. Any failure
  // follows href.
  function carts() {
    document.querySelectorAll('a[data-mb-add]').forEach(function (a) {
      if (!bind(a, 'Add')) return;
      a.addEventListener('click', function (ev) {
        if (!window.fetch) return;
        var ids = (a.getAttribute('data-mb-add') || '').split(',').filter(Boolean);
        if (!ids.length) return;
        ev.preventDefault();
        a.setAttribute('aria-busy', 'true');
        a.style.pointerEvents = 'none';
        var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        var json = { 'Content-Type': 'application/json', 'Accept': 'application/json' };
        var go = function () { openCart(a, root); };
        fetch(root + 'cart/add.js', { method: 'POST', headers: json,
          body: JSON.stringify({ items: ids.map(function (id) { return { id: +id, quantity: 1 }; }) }) })
          .then(function (r) { if (!r.ok) throw new Error('add ' + r.status); })
          .then(function () {
            // The offer's discount code (the free Melon) goes on with the
            // landing-page attributes; if it fails the cart still opens.
            var body = { attributes: { _lp: a.getAttribute('data-lp'), _lp_slot: a.getAttribute('data-slot') } };
            var code = a.getAttribute('data-mb-discount');
            if (code) body.discount = code;
            return fetch(root + 'cart/update.js', { method: 'POST', headers: json, body: JSON.stringify(body) })
              .catch(function () {});
          })
          .then(go)
          .catch(function () { window.location.href = a.href; });
      });
    });
  }

  // The single-Bloom buy box (snippets/funnls-bloom-buy-card.liquid): one-time
  // or Subscribe & save. Both states are rendered in Liquid; this only shows
  // one, and adds the variant - on the chosen selling plan when subscribing.
  function buys() {
    document.querySelectorAll('[data-mb-buy]').forEach(function (root) {
      if (!bind(root, 'Buy')) return;
      var mode = function () {
        var r = root.querySelector('input[type="radio"]:checked');
        return r ? r.value : (root.getAttribute('data-mode') || 'once');
      };
      var paint = function () {
        var m = mode();
        root.setAttribute('data-mode', m);
        root.querySelectorAll('[data-mb-txt]').forEach(function (el) {
          var t = el.getAttribute('data-' + m);
          if (t !== null) el.textContent = t;
        });
        root.querySelectorAll('[data-mb-show]').forEach(function (el) { el.hidden = el.getAttribute('data-mb-show') !== m; });
        root.querySelectorAll('.mb-buy__opt').forEach(function (l) {
          var i = l.querySelector('input');
          l.classList.toggle('is-on', !!i && i.checked);
        });
      };
      root.addEventListener('change', paint);
      paint();
      var btn = root.querySelector('[data-mb-buy-btn]');
      if (!btn) return;
      btn.addEventListener('click', function (ev) {
        if (!window.fetch) return;
        ev.preventDefault();
        btn.setAttribute('aria-busy', 'true');
        btn.style.pointerEvents = 'none';
        var item = { id: +root.getAttribute('data-variant'), quantity: 1 };
        if (mode() === 'sub') {
          var sel = root.querySelector('[data-mb-plan]');
          if (sel && sel.value) item.selling_plan = +sel.value;
        }
        var rt = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        var json = { 'Content-Type': 'application/json', 'Accept': 'application/json' };
        fetch(rt + 'cart/add.js', { method: 'POST', headers: json, body: JSON.stringify({ items: [item] }) })
          .then(function (r) { if (!r.ok) throw new Error('add ' + r.status); })
          .then(function () {
            return fetch(rt + 'cart/update.js', { method: 'POST', headers: json,
              body: JSON.stringify({ attributes: { _lp: root.getAttribute('data-lp'), _lp_slot: root.getAttribute('data-slot') } }) })
              .catch(function () {});
          })
          .then(function () { openCart(btn, rt); })
          .catch(function () { window.location.href = btn.href; });
      });
    });
    // The sticky bar's button presses the hero box's button, so what was picked there is what gets added.
    document.querySelectorAll('[data-mb-proxy]').forEach(function (a) {
      if (!bind(a, 'Proxy')) return;
      a.addEventListener('click', function (ev) {
        var target = document.querySelector('[data-mb-buy] [data-mb-cta="' + a.getAttribute('data-mb-proxy') + '"]');
        if (target) { ev.preventDefault(); target.click(); }
      });
    });
  }

  // What's inside (set pages, 2026-10-03): one product tab open at a time.
  function tabs() {
    document.querySelectorAll('[data-mb-tabs]').forEach(function (root) {
      if (!bind(root, 'Tabs')) return;
      var btns = root.querySelectorAll('[data-mb-tab]');
      var panels = root.querySelectorAll('[data-mb-panel]');
      function show(i, focus) {
        btns.forEach(function (b, n) {
          b.setAttribute('aria-selected', n === i ? 'true' : 'false');
          b.tabIndex = n === i ? 0 : -1;
          if (n === i && focus) b.focus();
        });
        panels.forEach(function (p, n) {
          p.removeAttribute('data-mb-later');
          p.hidden = n !== i;
          if (n === i) p.querySelectorAll('.mb-reveal').forEach(function (el) { el.classList.add('is-in'); });
        });
      }
      if (!btns.length) { panels.forEach(function (p) { p.removeAttribute('data-mb-later'); }); return; }
      show(0, false);
      btns.forEach(function (b, n) {
        b.addEventListener('click', function () { show(n, false); });
        b.addEventListener('keydown', function (e) {
          if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
            e.preventDefault();
            show((n + (e.key === 'ArrowRight' ? 1 : btns.length - 1)) % btns.length, true);
          }
        });
      });
    });
  }

  function init() { reveals(); galleries(); videos(); sticky(); jumps(); carts(); buys(); tabs(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
